import { render, staticRenderFns } from "./workspace_dropdown_item.vue?vue&type=template&id=01c0c4f6"
import script from "./workspace_dropdown_item.vue?vue&type=script&lang=js"
export * from "./workspace_dropdown_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports